import {Flex, Input, Stack} from '@chakra-ui/core';
import {useStateMachine} from 'little-state-machine';
import React from 'react';
import {darkgrey} from 'styles/constants';
import {Button} from './Button';
import {updateClientDetails} from 'store';
import {useForm} from 'react-hook-form';
import {debounce} from 'lodash';

export const ClientDetailsForm = ({setCurrentView, createPdf, loading}) => {
	const {actions, state} = useStateMachine({updateClientDetails});

	const {register, getValues} = useForm({
		defaultValues: {},
	});

	const onChange = () => {
		const formValues = getValues();
		actions.updateClientDetails(formValues);
	};

	const onSave = () => {
		createPdf();
	};

	return (
		<>
			<Stack w={'100%'}>
				<Stack w={'100%'} my={2}>
					{/* <FormLabel fontSize={'sm'} mb={0} m={0}>
						Company name
					</FormLabel> */}
					<Flex>
						<Input
							_placeholder={{opacity: 1, color: 'gray.600'}}
							color="#333"
							placeholder={'Company name'}
							defaultValue={state.clientDetails.clientCompany ?? ''}
							onInput={debounce(() => onChange(), 50)}
							{...register('clientCompany')}
						/>
					</Flex>
				</Stack>
				<Flex w={'100%'}>
					<Stack w={'100%'} my={2} mr={4}>
						{/* <FormLabel fontSize={'sm'} mb={0} m={0}>
							First name
						</FormLabel> */}
						<Flex>
							<Input
								_placeholder={{opacity: 1, color: 'gray.600'}}
								color="#333"
								placeholder={'First name'}
								defaultValue={state.clientDetails.clientFirstName ?? ''}
								onInput={debounce(() => onChange(), 50)}
								{...register('clientFirstName')}
							/>
						</Flex>
					</Stack>
					<Stack w={'100%'} my={2}>
						{/* <FormLabel fontSize={'sm'} mb={0} m={0}>
							Last name
						</FormLabel> */}
						<Flex>
							<Input
								_placeholder={{opacity: 1, color: 'gray.600'}}
								color="#333"
								placeholder={'Last name'}
								defaultValue={state.clientDetails.clientLastName ?? ''}
								onInput={debounce(() => onChange(), 50)}
								{...register('clientLastName')}
							/>
						</Flex>
					</Stack>
				</Flex>

				<Stack w={'100%'} mr={2}>
					{/* <FormLabel fontSize={'sm'} mb={0} m={0}>
						Email
					</FormLabel> */}
					<Flex>
						<Input
							_placeholder={{opacity: 1, color: 'gray.600'}}
							type={'email'}
							color="#333"
							placeholder={'Email'}
							defaultValue={state.clientDetails.clientEmail ?? ''}
							onInput={debounce(() => onChange(), 50)}
							{...register('clientEmail')}
						/>
					</Flex>
				</Stack>
			</Stack>

			<Flex mt={6}>
				<Button
					mr={2}
					w={2 / 3}
					mb={0}
					onClick={onSave}
					borderWidth={2}
					borderColor={darkgrey}
					isLoading={loading}
				>
					Download PDF
				</Button>
				<Button
					mb={0}
					w={1 / 3}
					isPrimary
					py={6}
					onClick={() => setCurrentView(2)}
					borderWidth={2}
					borderColor={darkgrey}
				>
					Go back
				</Button>
			</Flex>
		</>
	);
};
